export const SNS_SERVICE = {
  google: 'google',
  yahoo: 'yahoo'
}
